<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Threshold</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Threshold</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Form</h4>
            <p>Fill in the form to below</p>

            <b>
              <label for>Amount Covered Building</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.sum_covered_building"
              />
            </div>

            <b>
              <label for>Amount Covered Content</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.sum_covered_content"
              />
            </div>

            <b>
              <label for>Amount Covered Subsidence and Landslip Buy-Back</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.amount_covered_subsidence_and_landslip_buy_back"
              />
            </div>

            <b>
              <label for>Amount Covered Total</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.sum_covered_total"
              />
            </div>

            <b>
              <label for>Amount Covered Total Concrete Wood</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.sum_covered_total_concrete_wood"
              />
            </div>

            <hr />

            <b>
              <label for>Bicycle Amount Covered Min</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.bicycle_sum_covered_min"
              />
            </div>

            <b>
              <label for>Bicycle Amount Covered Max</label>
            </b>
            <div class="form-group">
              <input
                type="number"
                name
                id
                class="form-control"
                v-model="change.bicycle_sum_covered_max"
              />
            </div>

            <div class="form-group text-center mt-4">
              <button class="btn btn-success" @click="submitRequest()">
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "change_form_request",
  data() {
    return {
      change: {
        sum_covered_building: "",
        sum_covered_content: "",
        sum_covered_total: "",
        sum_covered_total_concrete_wood: "",
        amount_covered_subsidence_and_landslip_buy_back: "",

        bicycle_sum_covered_min: "",
        bicycle_sum_covered_max: ""
      }
    };
  },

  methods: {
    // load all purchases to save axios from keep making multiple queries in one page
    loadData() {
      // console.log(axios)
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/threshold/get_threshold", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            console.log(res.data);

            // Fire
            this.change.sum_covered_building = res.data.sum_covered_building;
            this.change.sum_covered_content = res.data.sum_covered_content;
            this.change.sum_covered_total = res.data.sum_covered_total;
            this.change.sum_covered_total_concrete_wood =
              res.data.sum_covered_total_concrete_wood;
            this.change.amount_covered_subsidence_and_landslip_buy_back =
              res.data.amount_covered_subsidence_and_landslip_buy_back;

            // Bicycle
            this.change.bicycle_sum_covered_min =
              res.data.bicycle_sum_covered_min;
            this.change.bicycle_sum_covered_max =
              res.data.bicycle_sum_covered_max;
          });
      }
    },
    submitRequest() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));
      let user_roles = user.roles;
      let role = "";

      user_roles.forEach(element => {
        if (element.id === 4) {
          role = 4;
        }
      });

      if (role !== 4) {
        swal({
          text: "You are not allowed to edit this form. Only Admin can edit.",
          icon: "warning",
          button: "OK"
        });
      } else {
        // check if has token
        if (token !== null) {
          token = JSON.parse(token);
          token = token.access_token;
          swal({
            icon: "warning",
            text: "Are you sure?",
            buttons: ["Cancel", "Yes"]
          }).then(confirm => {
            if (confirm) {
              let value = 0;

              for (let i = 1; i < 8; i++) {
                if (i == 1) {
                  value = this.change.sum_covered_building;
                } else if (i == 2) {
                  value = this.change.sum_covered_content;
                } else if (i == 3) {
                  value = this.change.sum_covered_total;
                } else if (i == 4) {
                  value = this.change.sum_covered_total_concrete_wood;
                } else if (i == 5) {
                  value = this.change.bicycle_sum_covered_min;
                } else if (i == 6) {
                  value = this.change.bicycle_sum_covered_max;
                } else if (i == 7) {
                  value = this.change.amount_covered_subsidence_and_landslip_buy_back;
                }
                axios
                  .put(
                    "/threshold/" + i,
                    {
                      value: value
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + token
                      }
                    }
                  )
                  .then(res => {
                    swal({
                      title: "Update success",
                      icon: "success",
                      text: "Threshold update successful"
                    });
                    return;
                  });
              }
            } else {
              swal({
                icon: "info",
                text: "Cancelled"
              });
            }
          });
        }
      }
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>
